import queryString from "query-string"

export default function appendUtmParams() {
  const utmValues = queryString.parse(window.location.search)
  return {
    LT_utm_source__c: utmValues.utm_source || "",
    LT_utm_campaign__c: utmValues.utm_campaign || "",
    LT_utm_medium__c: utmValues.utm_medium || "",
    lTutmcontent: utmValues.utm_content || "",
    lTutmterm: utmValues.utm_term || "",
  }
}
